import Vue from 'vue'
import VueMatomo from 'vue-matomo'
import { EventBus } from '~/plugins/eventbus.js'

export default (context) => { // { app: { router }, env, store }
  let router = context.app.router
  let $config = context.$config
  let store = context.store
  let state = store.state
  if ((($config.baseDomain === 'https://johku-marko.jalusta.com/' && state.shopId === 'marko') || $config.baseDomain === 'https://johku.com/' || $config.baseDomain === 'https://kube.johku.com/') && state.settings && state.locale && state.shopId && state.settings[state.shopId + '-' + state.locale] && state.settings[state.shopId + '-' + state.locale].global) {
 
    Vue.use(VueMatomo, {
      // Configure your matomo server and site by providing
      host: 'https://analytics.johku.com',
      siteId: state.settings[state.shopId + '-' + state.locale].global,

      // Changes the default .js and .php endpoint's filename
      // Default: 'matomo'
      trackerFileName: 'matomo',

      // Overrides the autogenerated tracker endpoint entirely
      // Default: undefined
      // trackerUrl: 'https://example.com/whatever/endpoint/you/have',

      // Overrides the autogenerated tracker script path entirely
      // Default: undefined
      // trackerScriptUrl: 'https://example.com/whatever/script/path/you/have',

      // Enables automatically registering pageviews on the router
      router: router,

      // Enables link tracking on regular links. Note that this won't
      // work for routing links (ie. internal Vue router links)
      // Default: true
      enableLinkTracking: true,

      // Require consent before sending tracking information to matomo
      // Default: false
      requireConsent: false,

      // Whether to track the initial page view
      // Default: true
      trackInitialView: false,

      // Run Matomo without cookies
      // Default: false
      disableCookies: true,

      // Require consent before creating matomo session cookie
      // Default: false
      requireCookieConsent: false,

      // Enable the heartbeat timer (https://developer.matomo.org/guides/tracking-javascript-guide#accurately-measure-the-time-spent-on-each-page)
      // Default: false
      enableHeartBeatTimer: false,

      // Set the heartbeat timer interval
      // Default: 15
      heartBeatTimerInterval: 15,

      // Whether or not to log debug information
      // Default: false
      debug: false,

      // UserID passed to Matomo (see https://developer.matomo.org/guides/tracking-javascript-guide#user-id)
      // Default: undefined
      userId: undefined,

      // Share the tracking cookie across subdomains (see https://developer.matomo.org/guides/tracking-javascript-guide#measuring-domains-andor-sub-domains)
      // Default: undefined, example '*.example.com'
      cookieDomain: undefined,

      // Tell Matomo the website domain so that clicks on these domains are not tracked as 'Outlinks'
      // Default: undefined, example: '*.example.com'
      domains: undefined,

      // A list of pre-initialization actions that run before matomo is loaded
      // Default: []
      // Example: [
      //   ['API_method_name', parameter_list],
      //   ['setCustomVariable','1','VisitorType','Member'],
      //   ['appendToTrackingUrl', 'new_visit=1'],
      //   etc.
      // ]
      preInitActions: [],

      // A function to determine whether to track an interaction as a site search
      // instead of as a page view. If not a function, all interactions will be
      // tracked as page views. Receives the new route as an argument, and
      // returns either an object of keyword, category (optional) and resultsCount
      // (optional) to track as a site search, or a falsey value to track as a page
      // view.
      // Default: false, i.e. track all interactions as page views
      // Example: (to) => {
      //   if (to.query.q && to.name === 'search') {
      //     return { keyword: to.query.q, category: to.params.category }
      //   } else {
      //    return null
      //   }
      // }
      trackSiteSearch: false
    })

    let basketTotal = () => {
      let total = 0
      for (var shopId in state.basketItems) {
        if (Object.prototype.hasOwnProperty.call(state.basketItems, shopId)) {
          let items = state.basketItems[shopId]
          for (var i = 0; i < items.length; i++) {
            let price = parseFloat(items[i].price) || 0
            if (items[i].resource_count && parseInt(items[i].resource_count, 10) > 1) {
              total += price * parseInt(items[i].count, 10) * parseInt(items[i].resource_count, 10)
            } else {
              total += price * parseInt(items[i].count, 10)
            }
          }
        }
      }
      return total
    }

    let addItems = (shopId, items) => {
      for (var i = 0; i < items.length; i++) {
        let item = items[i]
        let price = parseFloat(item.price) || 0
        if (item.resource_count && parseInt(item.resource_count, 10) > 1) {
          price = price * parseInt(item.resource_count, 10)
        }
        if (item.product_id) {
          window._paq.push(['addEcommerceItem',
            shopId + '-' + item.product_id, // (Required) productSKU
            item.product_name, // (Optional) productName
            [shopId], // (Optional) productCategory
            price, // (Recommended) price
            parseFloat(item.count) // (Optional, defaults to 1) quantity
          ])
        } else if (item.discount_id) {
          window._paq.push(['addEcommerceItem',
            shopId + '-dis-' + item.discount_id, // (Required) productSKU
            'Discount', // (Optional) productName
            [shopId], // (Optional) productCategory
            parseFloat(item.price), // (Recommended) price
            1 // (Optional, defaults to 1) quantity
          ])
        } else if (item.valuecard_id) {
          window._paq.push(['addEcommerceItem',
            shopId + '-vc-' + item.valuecard_id, // (Required) productSKU
            item.product_name, // (Optional) productName
            [shopId], // (Optional) productCategory
            parseFloat(item.price), // (Recommended) price
            1 // (Optional, defaults to 1) quantity
          ])
        } else if (item.voucher_id) {
          window._paq.push(['addEcommerceItem',
            shopId + '-voucher-' + item.voucher_id, // (Required) productSKU
            item.product_name, // (Optional) productName
            [shopId], // (Optional) productCategory
            parseFloat(item.price), // (Recommended) price
            1 // (Optional, defaults to 1) quantity
          ])
        } else if (item.commission_id) {
          window._paq.push(['addEcommerceItem',
            shopId + '-com-' + item.commission_id, // (Required) productSKU
            item.product_name, // (Optional) productName
            [shopId], // (Optional) productCategory
            parseFloat(item.price), // (Recommended) price
            1 // (Optional, defaults to 1) quantity
          ])
        }
      }
    }

    let trackOrder = (order) => {
      window._paq.push(['appendToTrackingUrl', 'new_visit=1'])
      window._paq.push(['trackEcommerceOrder',
        order.id, // (Required) orderId
        order.totalWithDelivery, // (Required) revenue
        order.total, // (Optional) subTotal
        order.totalVat, // (optional) tax
        parseFloat(order.totalWithDelivery) - parseFloat(order.total), // (optional) shipping
        false // (optional) discount
      ])
      window._paq.push(['appendToTrackingUrl', ''])
    }

    EventBus.$on('setBasketItems', () => {
      let count = 0
      for (let shopIdWithIndex in state.basketItems) {
        if (Object.prototype.hasOwnProperty.call(state.basketItems, shopIdWithIndex)) {
          let items = state.basketItems[shopIdWithIndex]
          let shopId = shopIdWithIndex.split('-')[0]
          count += items.length
          addItems(shopId, items)
        }
      }
      if (!count) {
        window._paq.push(['clearEcommerceCart'])
      }
      window._paq.push(['trackEcommerceCartUpdate', basketTotal()])
    })

    EventBus.$on('removedFromBasket', (data) => {
      if (data.item && data.shopId) {
        let id = '0'
        if (data.item.product_id) {
          id = data.item.product_id
        } else if (data.item.discount_id) {
          id = 'dis-' + data.item.discount_id
        } else if (data.item.valuecard_id) {
          id = 'vc-' + data.item.valuecard_id
        } else if (data.item.voucher_id) {
          id = 'voucher-' + data.item.voucher_id
        } else if (data.item.commission_id) {
          id = 'com-' + data.item.commission_id
        }
        id = data.shopId + '-' + id
        window._paq.push(['removeEcommerceItem',
          id // (Required) productSKU
        ])
      }
    })

    EventBus.$on('purchase', (data) => {
      if (data.items && data.shopIds) {
        let combinedOrder
        for (let i = 0; i < data.items.length; i++) {
          let shopId = data.shopIds[i]
          let order = data.items[i]
          addItems(shopId, order.ownItem)
          if (!combinedOrder) {
            combinedOrder = Object.assign({}, order)
          } else {
            combinedOrder.totalWithDelivery = parseFloat(combinedOrder.totalWithDelivery) + parseFloat(order.totalWithDelivery)
            combinedOrder.total = parseFloat(combinedOrder.total) + parseFloat(order.total)
            combinedOrder.totalVat = parseFloat(combinedOrder.totalVat) + parseFloat(order.totalVat)
          }
        }
        trackOrder(combinedOrder)
      }
    })

  }
}